// Spread for Range Estimates
export const SPREAD20 = 20 / 100; // 0,2

// EPS per Client Endpoint Factor
export const EPS_PER_CEF = 60 / 100; // 0,6

// FPM per Client Endpoint Factor
export const FPM_PER_CEF = 10;

// EPS per Server Factor
export const EPS_PER_SF = 2;

// FPM per Server Factor
export const FPM_PER_SF = 100;

/* 
# Inputs: 
[Worksations]
[Servers]

# Variables:
[RU Monthly Sub List Price] = 150 (Note: This value corresponds to part number D05M5ZX, and should be periodically updated through dsw API when we implement that integration)
[Discount] = 45%
[Enterprise SIEM RU Ratio] = 12
[Enterprise NDR RU Ratio] = 7
[Usage SIEM RU Ratio] = 120
[Usage NDR RU Ratio] = 300
[EPS_100_Paks] = same as for on-cloud
[FPM_10k_Paks] = same as for on-cloud
*/

// OnPrem [Discount] = 45% // changed to 35% 7.3.2022
export const ONPREM_DISCOUNT = 35 / 100; // 0,35
// [Enterprise SIEM RU Ratio] = 12
export const ENTERPRISE_SIEM_RU_RATIO = 12;
// [Enterprise NDR RU Ratio] = 7
export const ENTERPRISE_NDR_RU_RATIO = 7;
// [Usage SIEM RU Ratio] = 120
export const USAGE_SIEM_RU_RATIO = 120;
// [Usage NDR RU Ratio] = 300
export const USAGE_NDR_RU_RATIO = 300;
